export const ACTION_MAP = {
	create: { desc: '创建' },
	del: { desc: '删除' },
	view: { desc: '查看' },
	edit: { desc: '编辑' },
} as const
